import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import filterTypes from "data/filter-types";
import {
  FESTIVE_DAYS_LOADING,
  FESTIVE_DAYS_ERROR,
  FESTIVE_DAYS_ADD,
  FESTIVE_DAYS_UPDATE,
  FESTIVE_DAYS_DELETE,
  FESTIVE_DAYS_FILTERS,
  FESTIVE_DAYS_SEARCH,
  FESTIVE_DAYS_SINGLE,
  FESTIVE_DAYS_TYPES
} from "./constants";
import {
  requestAdd,
  requestUpdate,
  requestDelete,
  requestTypes
} from "./requests";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = (status) => ({
  type: FESTIVE_DAYS_LOADING,
  payload: status
});

export const festiveDaysTypes = () => dispatch => {
  requestTypes()
    .then(response => {
      dispatch({
        type: FESTIVE_DAYS_TYPES,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};

export const festiveDaysAdd = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  requestAdd(data)
    .then(response => {
      dispatch({
        type: FESTIVE_DAYS_ADD,
        payload: response.data.content
      });
      toast("Festive day created successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};

export const festiveDaysUpdate = (id, data, callback) => dispatch => {
  dispatch(setLoading(true));
  requestUpdate(id, data)
    .then(response => {
      dispatch({
        type: FESTIVE_DAYS_UPDATE,
        payload: response.data.content
      });
      toast("Festive day updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};

export const festiveDaysDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  requestDelete(id)
    .then(() => {
      dispatch({
        type: FESTIVE_DAYS_DELETE,
        payload: id
      });
      toast("Festive day removed successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};

export const festiveDaysFilters = () => dispatch => {
  requestCommonFilters("bonus")
    .then(response => {
      dispatch({
        type: FESTIVE_DAYS_FILTERS,
        payload: Object.keys(response.data.content).length ? response.data.content : []
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};

export const festiveDaysSearch = (page = 0, size = 10, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bonus", page, size, sort, filters)
    .then(response => {
      dispatch({
        type: FESTIVE_DAYS_SEARCH,
        payload: response
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};

export const festiveDaysSingle = (id) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bonus", null, 1, null, [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }])
    .then(response => {
      dispatch({
        type: FESTIVE_DAYS_SINGLE,
        payload: response
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, FESTIVE_DAYS_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/festive-days/actions.js